import script from "./index.vue?vue&type=script&setup=true&name=projectMange&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=projectMange&lang=js"

import "./index.vue?vue&type=style&index=0&id=0f632ef0&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f632ef0"]])

export default __exports__